export const semanticTypeUrl =
  "https://lhncbc.nlm.nih.gov/ii/tools/MetaMap/Docs/SemanticTypes_2018AB.txt";
export const umlsPredicateUrl =
  "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3281188/#__sec30title";
